import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select, Input, DatePicker, Tooltip, Radio, Checkbox, Button, Space, Popconfirm } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import { message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import modalStatus from '../../redux/reducers/permissao';
import Permissao from '../Permissao';
import ModalNovoOrgao from './ModalNovoOrgao';
import ModalEditarOrgao from './ModalEditarOrgao';

interface OrgaoProps {
    permissao?: any
    modalStatus?: any,
    setNovoOrgaoModal?: any,
    setEditarOrgaoModal?: any,
    setEditarFeriadoModal?: any,
    orgao?: any
}

const Orgao: React.FC<OrgaoProps> = (prop) => {
    let visible = prop.modalStatus[0].visibleNovoOrgao
    let orgao: any;
    let orgaos: any[] = [];
    const [orgaoResponse, setOrgaoResponse] = useState<any[]>();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;

    useEffect(() => {
        Buscar({ orgaoID: 0, Nome: "", Sigla: "" });
    }, [])

    useEffect(() => {
        Buscar({ orgaoID: 0, Nome: "", Sigla: "" });
    }, [prop.modalStatus[0]])

    const novoOrgao = async (values: any) => {
        prop.setNovoOrgaoModal(true);
    }
    const editarOrgao = async (values: any) => {
        prop.setEditarOrgaoModal(true, values);

    }
    const Buscar = async (values: any) => {
        await api.post(`Orgao/getcomfiltros`, {
            orgaoID: 0,
            Nome: values.nome,
            Sigla: values.sigla,
            Ativo: values.ativo == "" ? null : values.ativo === "true" ? true : false,
        })
            .then((response: any) => {
                if (response.status === 200) {
                    response.data.forEach((e: any) => {
                        orgao = {
                            key: e.orgaoID,
                            orgaoID: e.orgaoID,
                            nome: e.nome,
                            sigla: e.sigla,
                            ativo: e.ativo === true ? 'Sim' : 'Não',
                        }
                        orgaos.push(orgao);
                    });
                    setOrgaoResponse(orgaos);
                    setLoading(false);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            });

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    };

    const onActive = (record: any, chave: boolean) => {
        api.put(`Orgao`, {
            OrgaoID: record?.orgaoID,
            Nome: record?.nome,
            Sigla: record?.sigla,
            Ativo: chave
        })
            .then((response) => {
                if (response.data.valido) {
                    message.success(`Orgão ${chave ? 'ativo' : 'desativado'} com sucesso`)
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            }).finally(() => {
                Buscar({ orgaoID: 0, Nome: "", Sigla: "" });
                setLoading(false);
            });

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            prop.setEditarOrgaoModal(false);
        });
    };

    const columns: ColumnsType<any> = [
        {
            title: 'Nome',
            dataIndex: 'nome',
            width: '40%'
        },
        {
            title: 'Sigla',
            dataIndex: 'sigla',
            width: '30%'
        },
        {
            title: 'Ativo',
            dataIndex: 'ativo',
            width: '20%'
        },
        {
            title: 'Ações',
            key: 'action',
            render: (text, record: any) => (
                <Space size="middle">
                    {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button htmlType="button" onClick={() => editarOrgao(record)}>Editar</Button>
                        : null}
                    {
                        record.ativo == "Sim" ?
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.feriadoID} placement="top" title="Você tem certeza que deseja desativar esse órgao?" onConfirm={() => { onActive(record, false) }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.feriadoID} danger >  Desativar </Button>
                                </Popconfirm>
                                : null
                            :
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.feriadoID} placement="top" title="Você tem certeza que deseja ativar esse órgao?" onConfirm={() => { onActive(record, true) }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.feriadoID}  >  Ativar </Button>
                                </Popconfirm>
                                : null
                    }

                </Space>
            ),
            fixed: 'right' as 'right',
        }
    ];


    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={loading}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Nome"
                                        name="nome"
                                    >
                                        <Input placeholder="Informe o nome do órgão" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Sigla"
                                        name="sigla"
                                    >
                                        <Input placeholder="Informe a Sigla do órgão" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Ativo"
                                        name="ativo"
                                        initialValue=""
                                    >
                                        <Select placeholder="Ativo">
                                            <Option value="">Selecione</Option>
                                            <Option value="true">Sim</Option>
                                            <Option value="false">Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={novoOrgao} type="ghost" htmlType="button">
                                        Novo Órgão
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table loading={loading} columns={columns} dataSource={orgaoResponse} rowKey={"orgaoID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalNovoOrgao></ModalNovoOrgao>
            <ModalEditarOrgao></ModalEditarOrgao>
        </div>

    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Orgao);